module.exports = __webpack_public_path__ + "img/provider2.6181f971.jpg";